@let actions = actionsSg();
@let iconMode =
  actions.length === 1 && actions[0].icon
    ? {
        action: actions[0],
        handler: actionHandlerLookupSg()[0],
      }
    : undefined;
@let handlerLookup = actionHandlerLookupSg();

<!-- If number of overflowActions is one and there is an icon, we show that
icon, otherwise we show overflow icon -->
@if (iconMode) {
  <i
    [class]="iconMode.action.icon"
    (click)="iconMode.handler.execute()"
  ></i>
}
<!-- NOTE: We only want to show overflow icon, if there is actually some actions -->
@else if (actions.length > 0) {
  <i
    class="atn-icon atn-overflow atn-blue"
    (click)="overflowMenuStore.patchState({ presentOverflow: true })"
    #overflowActionOrigin
  ></i>
  @if (overflowMenuStore.presentOverflowSg()) {
    <atn-ds-attached-overlay
      [origin]="overflowActionOrigin"
      (backdropClick)="overflowMenuStore.patchState({ presentOverflow: false })"
    >
      <div class="atn-mosaic-overflow-actions">
        @for (actionRef of actionsSg(); track $index) {
          <div
            class="atn-mosaic-overflow-actions__action"
            (click)="handlerLookup[$index].execute()"
          >
            <div class="atn-mosaic-overflow-actions__action-name">
              <!-- Attempting to show name of the action, unless it's undefined.
               
              If action is referenced by alias or id we attempt to show it, otherwise we show operation name -->
              @if (isFlexibleIdentifier(actionRef.action)) {
                {{
                  actionRef.name ??
                    actionRef.action.alias ??
                    actionRef.action.id
                }}
              } @else {
                {{ actionRef.name ?? actionRef.action.operation }}
              }
            </div>
            @if (actionRef.icon) {
              <i [class]="actionRef.icon"></i>
            }
          </div>
        }
      </div>
    </atn-ds-attached-overlay>
  }
}
